import { ActionTypes } from '../actions';

const initialState = {
  current: {},
};

const NotebookReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_NOTEBOOK:
      return { current: action.payload };
    case ActionTypes.UPDATE_NOTEBOOK:
      return { current: action.payload };
    case ActionTypes.PATCH_NOTEBOOK:
      return { current: action.payload };
    default:
      return state;
  }
};

export default NotebookReducer;
